module.exports = __webpack_public_path__ + "static/8-3de51b0e196f7308321dcb1f7f723abb.jpg";